<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/rating/shared/product-reviews/product-reviews.component.ts
-->
<ng-template #anchor></ng-template>
